/*
 *	GrossDescription.js	Procedures to process Second Page load for Gross Description (or Specimens)
 *	2011-10-21	pkraft	Working initial version for opening ONE case in FF browser.
 *						Needs modularization and some generalization.
 *	Specimen.js			Name changed.  Reworked for rendering from PHP in multicolumn per row
 */

/**
 *	Construct a set of Specimen Gross Description tabs inside a container from data rendered by CommonViewDisplay
 *
 *	Identifier:					RENDER_COLUMN_MODE output HTML format:
 *	divListOuterContainer	-->	<div id="cViewSchemaList_..."  class="ListTable columns=""...>
 *	divListTableDiv			-->		<div class="ListTableDiv">
 *										<fieldset>
 *										<legend>
 *	divListCol_1			-->			<div style='width:50%'>
 *											<ul>
 *												<li>  actual stuff here
 *											</ul>
 *										</div>
 *	divListCol_2			-->			<div style='width:50%'>
 *											<ul>
 *												<li>  actual stuff here
 *											</ul>
 *										</div>
 *									</div>
 *									<table class="ListMargin ListFooter">
 *								</div>
 *
 * The above data is modified to this page content where M is Case ID, N1 is Specimen ID 1:
 * HTML:
 *  	<div id="cViewSchema_...IdM_" class="ListTable" "CaseM_SpecimenTabContainer" ...>
 *			<div id="CaseM_SpecimenTabN1" class="tab nested">
 *				<ul  class="tabs nested">
 *					<li><a href="#CaseM_SpecimenTab_N1"  class="tab nested">Specimen N1</a></li>  // where N1 replaced by ExternalSpecimenId if it exists
 *					<li> ... for all (N2, N3, ...)
 *				</ul>
 *				<div id="CaseM_SpecimenTab_N1" class="pane nested">
 *					<div class="ListTableDiv ViewFields" id="cViewSchema...IdM_N1 ...">
 *						<fieldset>
 *							<legend>
 *							<div style="width: 99%; float: right;" ...>
 *								<ul>
 *									<li> actual stuff here
 *								</ul>
 *							</div>
 *						</fieldset>
 *					</div>
 *					<div id="CaseM_PaneImages_N1" class="ViewImages>
 *						<ul>
 *							<li> imgs here
 *						</ul>
 *					</div>
 *					<div>
 *						<input id="CommandSectionEdit_N1" name="EditListcViewSchema_...IdM_N1" value="Edit" type="button">
 *					</div>
 *				</div> // All of the above MUST be in one container for EDIT to work on each pane
 *				<div id="CaseM_SpecimenTab_N2" class="pane nested">  ...for all (N2, N3, ...)
 *			</div> // All of the above DIV siblings MUST be in the same div and MUST be siblings for tabs to work
 *		</div>  // All of the above MUST be in one container for SAVE to work
 *
 *	JavaScript:
 *	$('.CaseM_SpecimenTabContainer').tabs();
 */

function BuildSpecimenTabs(workflow, outerDivId, listCaseId, uid)
{
	var divListOuterContainer = $('#' + outerDivId).find('div.ListTable');

	var activeTab = jsPAL.getSelectedTab($('#' + outerDivId));

	// activeTab = $('#' + outerDivId).tabs('option', 'selected');

	if (!(divListOuterContainer.length > 0))
	{
		// Get currently selected tab and set its class for no data found to display on tab
		var tabIndex = activeTab;
		$('#' + outerDivId).parent('.ui-tabs-panel').parent('.tabs').find('li').eq(tabIndex).find('a').addClass('NoDataOnTab');
		// Do something else here: a message, allow add button?...
		// $('div[id^="SecondPageURL"]').before('<p>No data to display</p>');
		return;
	}

	// Remove from selector any lists already in another case's tab(s). Use this so multiple cases can be opened at one time.
	// Kind of scarey to rely on this but it appears the new element is always the first one.
	// THIS DOESN'T WORK IN THIS CASE: It will pick up a previous container if the first case had no specimens.
	// DIV.ListTable
	if (divListOuterContainer.length > 1)
	{
		divListOuterContainer = divListOuterContainer.first();
	}

	var listId = divListOuterContainer.attr('id');
	var caseId = listCaseId;
	var specimenPrimaryKey = 0;

	divListOuterContainer.addClass('Case' + caseId + '_SpecimenTabContainer').addClass('tabs');

	// Find and remove the original edit button. ToDo: Copy this button contents and pass to OutputEditButton()
	var viewPrefix = 'cViewSchema_';
	var editButtonName = listId.substring(viewPrefix.length);
	var editButtonDiv = $('div input[name*="' + editButtonName + '"]').parent().parent().detach();
	// Begin building ul for tabs
	var tabUnorderedListHTML = "<ul class='tabs nested specimenTabs'>";
	// Determine number of specimen tabs to make
	var Records = divListOuterContainer.children();
	var numRecords = Records.length;
	if (Records.length > 0)
	{
		// remove first record if it is actually a header row and not specimen data row.
		// cList now always returns a header row even if there is no data
		if ($(Records[0]).find('ul.ListTable li').length == 0)
		{
			$(Records[0]).remove();
			Records = Records.splice(1);
			--numRecords;
		}

	}
	var specimenIds = new Array(); // or [] but that seemed not to work...
	var specimenLabels = [];
	var specimenModifieldLabels = [];
	var specimenIdStrings = [];
	specimenPrimaryKey = 0;
	var specimenLabel = '';
	var specimenModifiedLabel = false;

	// try to get case accession number from the input on the case tab
	// NOTE, Case Accession Number is called ExternalId in the database
	var caseAccession = $('input[tablename=Case][columnname=ExternalId][PrimaryKey=' + caseId + ']').val();
	if (undefined === caseAccession || '' === caseAccession)
	{
		// case tab must not have been loaded yet, try to get case accession number from the main grid
		caseAccession = jsPAL.getCaseCriticalColumnFromGrid(caseId, 'externalid');
	}
	if (undefined === caseAccession || '' === caseAccession)
	{
		// all else failed, read case accession number from the database
		Ajax(
		{
			type : "GET",
			url : "/AJAXDatabaseRead.php",
			data : 'TableName=Case&Columns=ExternalId&FilterFields[]=Case.Id&FilterOperators[]=%3D&FilterValues[]=' + caseId,
			async : false,
			success : function(msg)
			{
				var response = ParseJson(msg);
				if (response == null)
					return;
				caseAccession = response[0].ExternalId;
			}
		});
	}

	for ( var x = 0; x < numRecords; x += 1)
	{
		var ListItems = Records.eq(x).find('ul.ListTable li');
		if (ListItems.length === 0)
		{
			alert('No list items found');
			return;
		}
		var SpecimenAccessionNumberText = '';
		var SpecimenIdText = '';
		var foundAccessionNumber = false;
		var foundId = false;

		var Tags = ListItems.children('textarea,input,div,span.ExtraReadOnlyInfo');

		Tags.each(function()
		{
			if ($(this).attr('tablename') === 'Specimen')
			{
				if ($(this).attr('columnname') == 'AccessionNumber')
				{
					if ($(this).hasClass('ExtraReadOnlyInfo'))
					{
						// this is a readonly view, get the text this way
						SpecimenAccessionNumberText = $(this).text();
					}
					else
					{
						// not a readonly view, get the text directly
						SpecimenAccessionNumberText = $(this).val();
					}
					foundAccessionNumber = true;
				}
				if ($(this).attr('columnname') === 'SpecimenId')
				{
					specimenPrimaryKey = $(this).attr('downtospecimenbyparentid.id');
					if ($(this).hasClass('ExtraReadOnlyInfo'))
					{
						// this is a readonly view, get the text this way
						SpecimenIdText = $(this).text();
					}
					else
					{
						SpecimenIdText = $(this).val();
					}
					foundId = true
				}
				if (foundAccessionNumber && foundId)
				{
					return false; // break out of Tags.each()
				}
			}
		});
		if ((SpecimenAccessionNumberText != '') || (SpecimenIdText != ''))
		{
			specimenLabel = SpecimenAccessionNumberText + '-' + SpecimenIdText;
			// specimen label was not modified
			specimenModifiedLabel = false;
		}
		else
		{
			if (caseAccession !== '')
			{
				specimenLabel = caseAccession;
			}
			else
			{
				specimenLabel = 'Specimen ' + (x + 1);
			}
			SpecimenAccessionNumberText = specimenLabel;
			ListItems.find('input[tablename=Specimen][columnname=AccessionNumber]').val(specimenLabel);
			// specimen label was modified
			specimenModifiedLabel = true;
		}
		specimenIds.push(specimenPrimaryKey);
		specimenLabels.push(specimenLabel);
		specimenModifieldLabels.push(specimenModifiedLabel);
	}

	if (numRecords !== specimenIds.length)
	{
		// Should not happen, so issue alert
		alert("Specimen record(s) display error");
	}

	for ( var n = 0; n < Records.length; n++)
	{
		// Label each specimen record: CaseM_SpecimenNx .pane nested
		var Id = 'Case' + caseId + '_SpecimenTab_' + specimenIds[n];
		Records.eq(n).attr('id', Id).addClass('pane nested');
		specimenIdStrings.push(Id);

		specimenId = specimenIds[n];
		specimenLabel = specimenLabels[n];

		// Build the two sections required for jquery tabs(). The <ul> and <div>s MUST be siblings within one container <div>.
		tabUnorderedListHTML += "<li specimenId='" + specimenId + "' specimenLabel='" + specimenLabel + "' ><a href='#Case" + caseId + "_SpecimenTab_" + specimenId + "' class='tab nested CaseSpecimenTab'>" + specimenLabel + "</a></li>";

		var ColumnDivs = Records.eq(n).find('fieldset > div');

		for ( var col = 1; col <= ColumnDivs.length; col++)
		{
			var columnId = 'Case' + caseId + '_Specimen' + specimenId + '_Column' + col;
			ColumnDivs.eq(n).addClass('ViewFields').attr('id', columnId);
		}

		var newPaneImages = $('<div  id="Case' + caseId + '_Specimen' + specimenId + '_PaneImages" class=ViewImages><ul></ul></div>');

		// Move LI containing Image Thumbnail to pane images container if it exists, otherwise remove the LI
		var myImgLi = Array();
		if (SystemParms.DisplaySpecimenImagesInDetails)
		{
			myImgLi = Records.eq(n).find('img').closest('li');
		}
		if (myImgLi.length > 0)
		{
			myImgLi.detach().appendTo(newPaneImages.find('ul'));
			// change the onclick to call ViewGrossImageInBrowser rather than SingleViewWithImageScopeOrBrowser
			// this really should be done in AppendThumbnailHTMLNode, but that would require significant plumbing
			// changes to cList, cTable, etc. It is too late in the r12 project to do that.
			$(myImgLi.find('div.thumbnailDiv').find('a:first')).each(function() {
				var imageURL = $(this).find('img.ImageDelay').attr('image');
				// change:
				// 		/imageserver/@@e51HKrRPwKo6xu0v1niLvgAsFw8OB1u2gtTeHZ1UveTDsDhmUm7UtQ==/@2731?0+0+0+80+-1+80+S+0
				// to:
				//		/imageserver/@@e51HKrRPwKo6xu0v1niLvgAsFw8OB1u2gtTeHZ1UveTDsDhmUm7UtQ==/@2731?0+0
				imageURL = imageURL.substr(0, imageURL.lastIndexOf('?')) + '?0%2B0';
				$(this).attr('onclick', GetGrossImageOnClick(imageURL, specimenLabel));
			});
		}
		else
		{
			// No IMG, remove label and n/a
			var noImg = Records.eq(n).find('li span').filter(function(value)
			{
				return $(this).text() === 'Image Thumbnail';
			});
			if (noImg.length > 0)
			{
				var noImgParent = noImg.closest('li').remove();
			}
		}

		// move Specimen AccessionNumber to be next to the case ExternalId (case AccessionNumber)
		// and remove the label for Specimen AccessionNumber. set focus to the specimen accession
		// number on the first tab (n === 0)
		MoveSpecimenAccession(Records.eq(n), n === 0, specimenModifieldLabels[n]);

		// Add this section to page
		$('#Case' + caseId + '_SpecimenTab_' + specimenId).find('fieldset').append(newPaneImages);

		// Make and output Edit Buttons. Removing onclick allows binding to new button per tab
		var specimenEditButtonDiv = editButtonDiv.clone();
		specimenEditButtonDiv.find('input').attr('id', 'CommandSectionEdit_' + specimenId).attr('name', 'EditList' + listId + specimenId).removeAttr('onclick');
		$('#Case' + caseId + '_SpecimenTab_' + specimenId).append(specimenEditButtonDiv);
		if (jsPAL.getPALModuleName() === 'CaseAssembly')
		{
			// add a delete button
			addDeleteSpecimenButton($('#Case' + caseId + '_SpecimenTab_' + specimenId), specimenId);
			addUnassignSpecimenButton($('#Case' + caseId + '_SpecimenTab_' + specimenId), specimenId);
			addAddImageButton($('#Case' + caseId + '_SpecimenTab_' + specimenId), specimenId);
		}
		specimenId = 0;
	}

	// Add a New Specimen tab if this is the CaseAssembly workflow
	if (jsPAL.getPALModuleName() == 'CaseAssembly')
	{
		// first, create an empty div for the New Specimen tab's href
		$('.Case' + caseId + '_SpecimenTabContainer').append('<div class="ui-tabs-panel ui-widget-content ui-corner-bottom ui-tabs-hide" id="specimenFindSpecimensTabPanel' + uid + '"></div>');
		tabUnorderedListHTML += "<li><a onclick='$(document).trigger(\"PALRepositionCommandBar\");' href='#specimenFindSpecimensTabPanel" + uid + "' class='tab nested findSpecimenTab' style='cursor: pointer;'>Find Specimen</a></li>";
		var id = Math.floor(Math.random() * 10000);
		$('.Case' + caseId + '_SpecimenTabContainer').append('<div class="ui-tabs-panel ui-widget-content ui-corner-bottom ui-tabs-hide" id=' + id + '></div>');
		tabUnorderedListHTML += "<li class='newSpecimenTab'><a href='#" + id + "' onclick='addNewSpecimen(this, \"" + listCaseId + "\");return false;' class='tab nested' style='cursor: pointer;'>+New Specimen</a></li>";
	}
	// The first labels for the tabs
	tabUnorderedListHTML += '</ul>';
	$('.Case' + caseId + '_SpecimenTabContainer').prepend(tabUnorderedListHTML);
	// mark tab as modified if the accession number was modified
	$('.Case' + caseId + '_SpecimenTabContainer').find('li').find('a.CaseSpecimenTab').each(function(index) {
		var div = $(this).attr('href');
		if ($(div).find('.Modified').length > 0)
		{
			$(this).addClass('ModifiedTab');
			$('[aria-selected="true"]').children().addClass('ModifiedTab');
		}
	});

	// Remove errorBox as it is unneeded/unused
	$('#' + listId).find('.ListMargin').remove();

	// Clean up temporary and unnecessary items
	$('.ViewImages label').remove();

	// Bind Edit buttons to click event
	for ( var i = 0; i < specimenIds.length; i++)
	{
		$('#CommandSectionEdit_' + specimenIds[i]).bind('click', function()
		{
			$(this).parent().closest("div.pane").find(':input').attr('disabled', false); // need the closest or it doesn't ...bubble up?
			// add change handlers for the accssion and id inputs
			addSpecimenAccessionChangeHandlers();
		});
	}

	/***
	 *  After Visions, this sort was removed because Zoya wants specimens ordered by their entry into Spectrum
	 *  which is same as filter on GFRL dbo.Specimen query sorted by Id ascending

		// Sort the labels: alphabetically ascending
		specimenLabels.sort();
		$.each(specimenLabels, function (index, value)
		{
			var search = 'Specimen ' + value;
			//alert ('ARRAY: ' + s2 );
			var theLi = $('#' + outerDivId).find('li a.tab.nested').filter(function()
			{
				return $(this).text() === search;
			}).parent('li').detach();
			$('#' + outerDivId).find(' ul.tabs.nested').append(theLi);

		});
	***/
	$(document).unbind('ValidateInputs');
	$(document).bind('ValidateInputs', function()
	{
		// don't allow blank accession numbers
		var inputs = $('input[tablename="Specimen"][columnname="AccessionNumber"]');
		inputs.each(function(){
			if ($(this).val().trim() == '')
			{
				// cancel the SaveAll
				jsPAL.cmdBar.cancelSave();
				var input = $(this);
				// get the index of the tab that contains this input
				var idx = input.closest('.ListTableDiv').index();
				// select the tab that contains the input
				input.closest('.tabs').tabs('option', 'active', idx - 1);
				var dlg = $('<div class="BlankAccessionError"><br/>Please Enter a Specimen Acc#</div>').dialog({
					modal: true,
					resizable: false,
					title: 'Acc# is blank',
					position: [input.offset().left + 50, input.offset().top - 20],
					height: 'auto',
					buttons :
					{
						"OK" : function()
						{
							dlg.dialog('close');
						}
					},
					close: function ()
					{
						dlg.remove();
						input.focus();
					}
				});
				// break out of .each as soon as the first invalid input is found
				return false;
			}
		});
	});
	$(document).on('PALTabClosing.Specimen', function (event, tabDivId) {
			// cleanup all specimen related divs when closing the tab
			$(tabDivId).empty();
		}
	);
	// Finally, the structure is in place so make the tabs
	$('.Case' + caseId + '_SpecimenTabContainer').tabs();
	// add change handlers for accession number and specimen id. the handlers update the specimen tab text
	addSpecimenAccessionChangeHandlers();

	// locking logic for the slide related grids
	var isCurrentSelectedCaseLocked = AlreadyOpenedCases[caseId].isLocked;
	var tabLockedUponCreation = isCurrentSelectedCaseLocked;
	jsPAL.performLockingTabLogic(outerDivId, tabLockedUponCreation);
	jsPAL.workflowSpecificLockingTabLogic(outerDivId, !tabLockedUponCreation);
}

/*
 * Specimen tab functions
 */

function addDeleteSpecimenButton(specimenDiv, specimenId)
{
	// make sure there's not a delete button in the div already
	if (specimenDiv.find('.delete-specimen-button').length === 0)
	{
		var onclick = "deleteSpecimen(" + specimenId + ",this);";
		specimenDiv.append('<input type="button" class="delete-specimen-button ui-button ui-widget ui-state-default ui-corner-all ui-button-text-only" value="Delete" title="Delete" onclick="' + onclick + '" />');
	}
}
function addUnassignSpecimenButton(specimenDiv, specimenId)
{
	// make sure there's not a delete button in the div already
	if (specimenDiv.find('.unassign-specimen-button').length === 0)
	{
		var onclick = "unAssignSpecimen(" + specimenId + ",this);";
		specimenDiv.append('<input type="button" class="unassign-specimen-button ui-button ui-widget ui-state-default ui-corner-all ui-button-text-only" value="Unassign" title="Unassign" onclick="' + onclick + '" />');
	}
}
function addAddImageButton(specimenDiv, specimenId)
{
	// make sure there's not an add image button in the div already
	if (specimenDiv.find('.specimen-addimage-button').length === 0)
	{
		var onclick = "addImage(" + specimenId + ", this, jsPAL.getSelectedTabText($('.specimenTabs').filter(':visible').parent()))";
		specimenDiv.append('<input type="button" class="specimen-addimage-button ui-button ui-widget ui-state-default ui-corner-all ui-button-text-only" value="Add Image" title="Add an Image to this Specimen" onclick="' + onclick + '" />');
	}
}
function deleteSpecimen(specimenId, deleteButton)
{
	$(document).one('PALDeleteSpecimenFromCase', function() {
		// refresh the DST and uScope to remove the specimen
		jsPAL.viewer.refreshVILRequired();
	});
	// delete the specimen
	jsPAL.deleteElement(specimenId, 'Specimen', deleteButton, 'PALDeleteSpecimenFromCase');
}

function unAssignSpecimen(specimenId, unassignButton)
{
	$(document).one('PALUnassignSpecimenFromCase', function() {
		// refresh the DST and uScope. This is necessary because the specimen may have had
		// slides assigned to it which will need to be removed from the DST.
		jsPAL.viewer.refreshVILRequired();
	});
	jsPAL.unassignElement(specimenId, 'Specimen', unassignButton, 'PALUnassignSpecimenFromCase')
}

function addImage(specimenId, addImageButton, specimenLabel)
{
	jsPAL.addImageToSpecimen(specimenId, addImageButton, specimenLabel);
}

function removeSpecimenTab(specimenId, deleteButton)
{
	var specimenTabsDiv = $(deleteButton).closest('.tabs');
	var tabs = jsPAL.getTabsForDiv(specimenTabsDiv);
	$(tabs).each(function(tabIndex)
	{
		if ($(this).attr('specimenid') == specimenId)
		{
			// whan a tab is closed, jquery selects the tab that is immediately to the right
			// of the tab that is being closed. if the closing tab is the last specimen tab, then jquery
			// will select the New Specimen tab which is to its right, and create a new specimen.
			// As a workaround, set a flag to prevent the New Specimen logic from adding a new specimen
			jsPAL.closingTab = true
			jsPAL.closeTabByIndex(specimenTabsDiv, tabIndex);
			jsPAL.closingTab = false;
			return false;
		}
	});

}

// change handlers for accession number and specimen id. the handlers update the specimen tab text
function addSpecimenAccessionChangeHandlers()
{
	// add keyup and change handlers to update the specimen tab text
	$("input[columnname=AccessionNumber][tablename=Specimen]").on('keyup', function()
	{
		updateSpecimenTabText(this);
	}).on('change', function()
	{
		updateSpecimenTabText(this);
	});
	$("input[columnname=SpecimenId][tablename=Specimen]").on('keyup', function()
	{
		updateSpecimenTabText(this);
	}).on('change', function()
	{
		updateSpecimenTabText(this);
	});
}
function updateSpecimenTabText(input)
{
	var specimenTabDiv = $(input).closest('.ui-tabs');
	var AccessionNumber = specimenTabDiv.find('input[columnname=AccessionNumber][tablename=Specimen]').filter(':visible').val();
	var SpecimenId = specimenTabDiv.find('input[columnname=SpecimenId][tablename=Specimen]').filter(':visible').val();
	if (undefined !== SpecimenId && '' !== SpecimenId)
	{
		AccessionNumber += '-' + SpecimenId;
	}
	jsPAL.setSelectedTabText(specimenTabDiv, AccessionNumber);
}

// move specimen id input to be next to the specimen accession number
// if bSetFocus is true, set focus to the specimen id, used for non-readonly views only
function MoveSpecimenAccession(Record, bSetFocus, bModifiedAccessionNumber)
{
	// first, attempt to get specimen accession and id from ExtraReadOnlyInfo
	var specimenAccession = Record.find('span.ExtraReadOnlyInfo[columnname=AccessionNumber]');
	var specimenId = Record.find('span.ExtraReadOnlyInfo[columnname=SpecimenId]');
	if ((specimenAccession.length > 0) && (specimenId.length > 0))
	{
		// this is a readonly view, we need to replace the accesion number with accession number-id
		var accessionText = specimenAccession.text();
		var idText = specimenId.text();
		specimenAccession.text(accessionText + '-' + idText);
		var label = specimenId.siblings('label');
		label.remove();
		specimenId.remove();
	}
	else
	{
		// not a readonly view, move the specimen id to be immediately to the
		// right of the specimenAccession
		// and remove the specimen id label
		specimenAccession = Record.find('input[columnname=AccessionNumber][tablename=Specimen]');
		specimenId = Record.find('input[columnname=SpecimenId][tablename=Specimen]');
		var label = Record.find('label[for="' + specimenId.attr('id') + '"]');
		if (label.length === 0)
		{
			return; // it's already been done
		}
		label.detach();

		var curWidth = parseInt(specimenAccession.css('width'));
		curWidth -= 50;
		specimenAccession.css('width', curWidth.toString() + 'px');
		specimenId.css('width', '40px');
		// move the specimen id to immediately follow the accession number
		specimenId.detach().insertAfter(specimenAccession);
		if (bSetFocus)
		{
			specimenId.focus();
		}
		// if accession number was modified (set to the case external id), set the Modified class
		if (bModifiedAccessionNumber)
		{
			specimenAccession.addClass('Modified');
		}
	}
}

// assign selected slides to the specimen
function AssignSlides(gridDivId)
{
	var slideCount = 0;
	var tabhref = $('#MainTabs').find('[aria-selected="true"]').find('a').attr('href');
	var div = $('#MainTabs').find(tabhref);
	tabhref = div.find('[aria-selected="true"]').find('a').attr('href');
	div = div.find(tabhref);
	var tab = div.find('[aria-selected="true"]');

	var specimenid = tab.attr('specimenid');
	var data = 'Command=BulkAddToExistingParent&TableName=Slide&ParentTableName=Specimen&ParentId=' + specimenid;
	for (rowId in SlideGridSelectedRows)
	{
		data += '&Ids[]=' + rowId;
		++slideCount;
	}
	if (slideCount == 0)
	{
		alert('You have not selected any slides to assign');
		return;
	}

	Ajax(
	{
		type : "Post",
		url : "/BulkAction.php",
		data : data,
		success : function(data)
		{
			jsPAL.displayNotification('Slides Assigned to Specimen');
			var grid = $('#' + gridDivId).find('.ui-jqgrid-btable');
			grid.trigger('reloadGrid',
			[
			{
				page : 1
			}]);
			if (undefined !== SlideGridSelectedRows)
			{
				delete SlideGridSelectedRows;
			}
			SlideGridSelectedRows = new Object();
		},
		error : function(jqXHR, textStatus, errorThrown)
		{
			alert("Error Assigning Slides to Specimen");
		}
	});
}

// assign selected specimens to the case
function AssignSpecimens(gridDivId)
{
	var specimenCount = 0;
	var div = jsPAL.getTabPanelDiv($('#MainTabs'), jsPAL.getSelectedTabIndex($('#MainTabs')));

	var caseid = div.attr('primarykey');
	var data = 'Command=BulkAddToExistingParent&TableName=Specimen&ParentTableName=Case&ParentId=' + caseid;
	for (rowId in SpecimenGridSelectedRows)
	{
		data += '&Ids[]=' + rowId;
		++specimenCount;
	}
	if (specimenCount == 0)
	{
		alert('You have not selected any slides to assign');
		return;
	}

	Ajax(
	{
		type : "Post",
		url : "/BulkAction.php",
		data : data,
		success : function(data)
		{
			jsPAL.displayNotification('Specimens Assigned to Case');
			var grid = $('#' + gridDivId).find('.ui-jqgrid-btable');
			grid.trigger('reloadGrid',
			[
			{
				page : 1
			}]);
			if (undefined !== SpecimenGridSelectedRows)
			{
				delete SpecimenGridSelectedRows;
			}
			SpecimenGridSelectedRows = new Object();
		},
		error : function(jqXHR, textStatus, errorThrown)
		{
			alert("Error Assigning Specimens to Case");
		}
	});
}

/*
 * jsCaseAssemblySpecimen contains code for the Case Assembly Specimen tab
 */
var jsCaseAssemblySpecimen = new function()
{
	this.init = function(outerDivId, uid, caseId)
	{
		// bind a function to reload the CaseAssembly_Slide_Grid_Specimen grid when a specimen tab is selected
		var specimenTabDiv = $('#' + outerDivId).children('div').first();
		specimenTabDiv.attr('caseid', caseId);
		specimenTabDiv.bind('tabsactivate', function(event, ui)
		{
			jsCaseAssemblySpecimen.specimenTabClicked(specimenTabDiv, ui.newTab.index(), uid);
		});

		// by default tab panels have a min-height specified in PALStyles.css, which pushes the Slides and Find Slides tab row too far down,
		// lessen the min height to get rid of the white space between the specimen info and the tab row
		$('#' + outerDivId).find('.ui-tabs-panel').css('min-height', '200px');

		// set up a new tab row (id = specimenSlideTabs) containing the Slides and Find Slides tabs
		$('#' + outerDivId).append('<div id=\"specimenSlideTabs' + uid + '\" class=specimenSlideTabRow><ul></ul></div>');
		var tabs = $('#specimenSlideTabs' + uid);
		tabs.tabs();
		jsPAL.createTab(tabs, 'specimenSlideGridTabPanel' + uid, 0, 'Assigned eSlides', '');
		jsPAL.createTab(tabs, 'specimenFindSlidesTabPanel' + uid, 0, 'Find eSlides', '');
		tabs.find('.ui-tabs-panel').css('min-height', '350px');

		// selectedTab is the tab for first newly added specimen, or tab 0 if not adding new specimen(s)
		var selectedTab = 0;
		if (jsPAL.numSpecimensToAdd > 0)
		{
			// if new specimens were just added, select the tab for the first of those specimens
			selectedTab = Math.max($('.Case' + caseId + '_SpecimenTabContainer').find('.CaseSpecimenTab').length - jsPAL.numSpecimensToAdd, 0);
		}
		// tab is positioned before the 'Find Specimen' tab
		var specTabContainer = $('.Case' + caseId + '_SpecimenTabContainer');
		var tabPos = Math.max(jsPAL.getTabIndexByText(specTabContainer, 'Find Specimen'), 0);
		jsPAL.createTab(specTabContainer, 'assignedSpecimensGridTabPanel' + uid, tabPos, 'Assigned Specimens', '');
		jsPAL.selectTab(specTabContainer, selectedTab);
		var url = '/PALModules/healthcare/CommonViewDisplay.php';
		var data = 'workFlow[0]=CaseAssembly' +
				'&viewName[0]=CaseAssembly_Specimen_Grid_Specimen' +
				'&renderMode[0]=Grid' +
				'&Table[0][0]=Specimen' +
				'&FieldName[0][0]=ParentId' +
				'&FieldOperator[0][0]=%3D' +	// %3D is =
				'&FieldValue[0][0]=' + caseId +
				'&SortByField[0]=Id' +
				'&SortByOrder[0]=Ascending' +
				'&GridRowPrimaryKey[0]=Id' +
				'&gridActions[0][0][0][name]=UnassignSpecimen' +
				'&gridActions[0][0][0][type]=Unassign'+
				'&gridActions[0][0][0][icon]=/Images/Unassign.png' +
				'&gridActions[0][0][0][action]=unassignSpecimen' +
				'&gridActions[0][0][0][title]=Unassign' +
				'&gridActions[0][1][0][name]=DeleteSpecimen' +
				'&gridActions[0][1][0][type]=Delete' +
				'&gridActions[0][1][0][icon]=/Images/deletePatient.png' +
				'&gridActions[0][1][0][action]=deleteSpecimen' +
				'&gridActions[0][1][0][title]=Delete' +
				'&CaseId=' + caseId;
				Ajax(
				{
					type: 'POST',
					url: url,
					data: data,
					success: function (html, textStatus, jqXHR)
					{
						html = ParseAjaxResponse(html, 'html');
						if (html)
						{
							$('#assignedSpecimensGridTabPanel' + uid).append(html);
							// after the main grid loads, load the other hidden grids
							jsCaseAssemblySpecimen.loadRemainingGrids(caseId, uid, outerDivId);
						}
					}
				});
	};
	this.loadRemainingGrids = function(caseId, uid, outerDivId)
	{
		// build a list of datagroup id's that the user has full access to
		var dataGroupArray = [];
		for (var i = 0; i < SystemParms.UserDataGroups.length; i++)
		{
			var UserDataGroup = SystemParms.UserDataGroups[i];
			if ((UserDataGroup.Access === 'Full') && (UserDataGroup.ParentDataGroupId == ""))
			{
				dataGroupArray.push(UserDataGroup.DataGroupName);
			}
		}
		dataGroups = dataGroupArray.join(',');

		var specimenTabDiv = $('#' + outerDivId).children('div').first();
		// Load the CaseAssembly_Slide_Grid_Specimen grid into the Slides tab
		url =   '/PALModules/healthcare/CommonViewDisplay.php';
		data =  'workFlow[0]=CaseAssembly' +
				'&viewName[0]=CaseAssembly_Slide_Grid_Specimen'+
				'&renderMode[0]=Grid' +
				'&Table[0][0]=Slide' +
				'&FieldName[0][0]=ParentId' +
				'&FieldOperator[0][0]=%3D' +	// %3D is =
				'&FieldValue[0][0]=0' + // the ParentId of 0 is replaced at run time by specimenTabClicked when a a specimen tab is clicked
				'&Table[0][0]=Slide' +
				'&FieldName[0][0]=ParentTable' +
				'&FieldOperator[0][0]=%3D' +	// %3D is =
				'&FieldValue[0][0]=Specimen' +
				'&LoadData[0]=false' +	// don't load this grid until the use clicks on a specimen tab
				'&GridRowPrimaryKey[0]=Id' +
				'&SortByField[0]=Id' +
				'&SortByOrder[0]=Ascending' +
				'&gridActions[0][0][0][name]=UnassignSlide' +
				'&gridActions[0][0][0][type]=Unassign' +
				'&gridActions[0][0][0][icon]=/Images/Unassign.png' +
				'&gridActions[0][0][0][action]=unassignSlideFromSpecimen' +
				'&gridActions[0][0][0][title]=Unassign'+
				'&gridActions[0][1][0][name]=EditSlide' +
				'&gridActions[0][1][0][type]=Edit' +
				'&gridActions[0][1][0][icon]=/Images/editPatient.png' +
				'&gridActions[0][1][0][action]=editSpecimenSlide' +
				'&gridActions[0][1][0][title]=Edit' +
				'&gridActions[0][2][0][name]=DeleteSlide' +
				'&gridActions[0][2][0][type]=Delete' +
				'&gridActions[0][2][0][icon]=/Images/deletePatient.png' +
				'&gridActions[0][2][0][action]=deleteSpecimenSlide' +
				'&gridActions[0][2][0][title]=Delete' +
				'&CaseId=' + caseId;
				Ajax(
				{
					type: 'POST',
					url: url,
					data: data,
					success: function (html, textStatus, jqXHR)
					{
						html = ParseAjaxResponse(html, 'html');
						if (html)
						{
							$('#specimenSlideGridTabPanel' + uid).append(html);
							// click tab 0, or the first newly added specimen, to load the XXX_Slide_Grid_Specimen grid with the specimen's slides
							var selectedTab = 0;
							if (jsPAL.numSpecimensToAdd > 0)
							{
								// if new specimens were just added, select the tab for the first of those specimens
								selectedTab = Math.max($('.Case' + caseId + '_SpecimenTabContainer').find('.CaseSpecimenTab').length - jsPAL.numSpecimensToAdd, 0);
								jsPAL.numSpecimensToAdd = 0;
							}
							jsCaseAssemblySpecimen.specimenTabClicked(specimenTabDiv, selectedTab, uid);
						}
					}
				});

		// Load theCaseAssembly_UnassignedSlide_Grid_Slide grid into the Find Slides tab
		var isCurrentSelectedCaseLocked = AlreadyOpenedCases[caseId].isLocked;
		if (isCurrentSelectedCaseLocked == false)
		{
			url =   '/PALModules/healthcare/CommonViewDisplay.php';
			data = 'workFlow[0]=CaseAssembly' +
				'&viewName[0]=CaseAssembly_UnassignedSlide_Grid_Slide' +
				'&renderMode[0]=Grid' +
				'&Table[0][0]=Slide' +
				'&FieldName[0][0]=ParentId' +
				'&FieldOperator[0][0]=IsNULL' +
				'&FieldValue[0][0]=0' +
				'&Table[0][1]=Slide' +
				'&FieldName[0][1]=DataGroupId' +
				'&FieldOperator[0][1]=in' +
				'&FieldValue[0][1]=' + dataGroups +
				'&LoadData[0]=true' +
				'&SortByField[0]=Id' +
				'&SortByOrder[0]=Ascending' +
				'&GridRowPrimaryKey[0]=Id' +
				'&gridActions[0][0][0][name]=AssignSlide' +
				'&gridActions[0][0][0][type]=Assign' +
				'&gridActions[0][0][0][icon]=/Images/Assign.png' +
				'&gridActions[0][0][0][action]=assignSlideToSpecimen' +
				'&gridActions[0][0][0][title]=Assign'+
				'&CaseId=' + caseId;
				Ajax(
				{
					type: 'POST',
					url: url,
					data: data,
					success: function (html, textStatus, jqXHR)
					{
						html = ParseAjaxResponse(html, 'html');
						if (html)
						{
							$('#specimenFindSlidesTabPanel' + uid).append(html);
							// Move the slide search div into the Find Slides tab before the CaseAssembly_Slide_Grid_Specimen grid
							$('#specimenFindSlidesTabPanel' + uid).prepend($('#unassignedSlidesDiv' + uid));
							$('#unassignedSlidesDiv' + uid).show();
							$('#specimenFindSlidesTabPanel' + uid).click(function()
							{
								ajax_options_hide();
								HideSearchParamSelection();
							});
						}
					}
				});
		// Load CaseAssembly_UnassignedSpecimen_Grid_Specimen grid into the Find Specimens tab
			url =  '/PALModules/healthcare/CommonViewDisplay.php';
			data = 'workFlow[0]=CaseAssembly' +
				'&viewName[0]=CaseAssembly_UnassignedSpecimen_Grid_Specimen' +
				'&renderMode[0]=Grid' +
				'&Table[0][0]=Specimen' +
				'&FieldName[0][0]=ParentId' +
				'&FieldOperator[0][0]=IsNULL' +
				'&FieldValue[0][0]=0'+
				'&Table[0][1]=Specimen' +
				'&FieldName[0][1]=DataGroupId' +
				'&FieldOperator[0][1]=in' +
				'&FieldValue[0][1]=' + dataGroups +
				'&LoadData[0]=false' +	// don't load this grid until the user clicks the Find Specimen tab
				'&GridRowPrimaryKey[0]=Id'+
				'&SortByField[0]=Id' +
				'&SortByOrder[0]=Ascending' +
				'&gridActions[0][0][0][name]=AssignSpecimen'+
				'&gridActions[0][0][0][type]=Assign'+
				'&gridActions[0][0][0][icon]=/Images/Assign.png'+
				'&gridActions[0][0][0][action]=assignSpecimenToCase'+
				'&gridActions[0][0][0][title]=Assign' +
				'&CaseId=' + caseId;
				Ajax(
				{
					type: 'POST',
					url: url,
					data: data,
					success: function (html, textStatus, jqXHR)
					{
						html = ParseAjaxResponse(html, 'html');
						if (html)
						{
							$('#specimenFindSpecimensTabPanel' + uid).append(html);
							// Move the specimen search div into the Find Specimens tab after the grid has been loaded
							$('#specimenFindSpecimensTabPanel' + uid).prepend($('#unassignedSpecimensDiv' + uid));
							$('#unassignedSpecimensDiv' + uid).show();
							$('#specimenFindSpecimensTabPanel' + uid).click(function()
							{
								ajax_options_hide();
								HideSearchParamSelection();
							});
						}
					}
				});
		}
	};
	// set the filters for the find specimen or find slide grid, then reload the grid
	// table is the Spectrum tablename to search(Specimen or Slide)
	// divId is the id of the div that contains the search controsl
	// gridName is the name of the grid to apply the filters to
	this.SetFindGridFilters = function(table, divId, gridName)
	{
		var slideFilter = false;
		var specimenFilter = false;
		function setFilterTable(table)
		{
			if (table == 'Slide')
				slideFilter = true;
			else if (table == 'Specimen')
				specimenFilter = true;
		}
		// set initial filter values for the grid view. Must be the same filters as in cCaseAssemblyWorkflowBuilder.php
		var FilterTables = new Array(table);
		var FilterColumns = new Array('ParentId');
		var FilterOperators = new Array('IsNULL');
		var FilterValues = new Array('');
		var FilterValues2 = new Array();
		setFilterTable(table);

		// get the filter values. they are in arrays of inputs named Table[], FieldName[], FieldValue[],
		// and a select named FieldOperator[]
		// the search filters selected by the user are contained in <input>s and a <select> in a <table>
		var findTabPanel = $('#' + divId);
		var filterTables = findTabPanel.find('table[id*="TableSpecimen"], table[id*="TableSlide"]');
		// search only the visible rows
		filterTables.find('tr').filter(':visible').each(function()
		{
			var row = $(this);
			row.find('td').each(function()
			{
				var td = $(this);
				td.find('input').each(function()
				{
					var name = $(this).attr('name');
					if (name === 'Table[]')
					{
						var tbl = $(this).val();
						FilterTables.push(tbl);
						setFilterTable(tbl);
					}
					else if (name === 'FieldName[]')
					{
						FilterColumns.push($(this).val());
					}
					else if (name === 'FieldValue[]')
					{
						FilterValues.push($(this).val());
					}
					// used with range operator  and collect only visible
					else if (name === 'FieldValue2[]')
					{
						if( $(this).is(':visible') )
						{
							FilterValues2.push($(this).val());
						}
					}
				});
				td.find('select').each(function()
				{
					var name = $(this).attr('name');
					if (name === 'FieldOperator[]')
					{
						FilterOperators.push($(this).find(':selected').val());
					}
				});
			});
		});
		if (specimenFilter && slideFilter)
		{
			// if searching for specimens filtered by slide fields, need to add a filter where Slide.ParentTable = 'Specimen'
			FilterTables.push('Slide');
			FilterColumns.push('ParentTable');
			FilterOperators.push('=');
			FilterValues.push('Specimen');
		}
		// last 'Full' parameter means filter by DataGroup where access is Full
		jsPAL.LoadFilteredGrid(gridName, divId, FilterTables, FilterColumns, FilterOperators, FilterValues, FilterValues2, 'Full');
	};
	// assign an unassigned slide to the current specimen
	this.AssignSlideToSpecimen = function(slideid)
	{
		if (confirm('Assign this Slide to the Specimen?'))
		{
			var caseDiv = jsPAL.getSelectedTabPanelDiv($('#MainTabs'));
			// sanity check, make sure we're really on a case tab
			if (caseDiv.attr('tablename') === 'case')
			{
				var caseId = caseDiv.attr('primarykey');
				var specimenTabs = $('.Case' + caseId + '_SpecimenTabContainer');
				var specimenId = jsPAL.getSelectedTab(specimenTabs).attr("specimenid");
				if (undefined !== specimenId && '' !== specimenId)
				{
					jsPAL.assignElement("Slide", slideid, "Specimen", specimenId, 'PALAssignSlideToSpecimen');
					// call VIL function to update the DST and uScope
					jsPAL.viewer.refreshVILRequired();
				}
			}
		}
	};
	// unassign an assigned slide from the current specimen
	this.UnassignSlideFromSpecimen = function(slideId, table, controlId)
	{
		var caseDiv = jsPAL.getSelectedTabPanelDiv($('#MainTabs'));
		// sanity check, make sure we're really on a case tab
		if (caseDiv.attr('tablename') === 'case')
		{
			if (jsPAL.unassignElement(slideId, table, controlId, "PALUnassignSlideFromSpecimen"))
			{
				// call VIL function to update the DST and uScope
				jsPAL.viewer.refreshVILRequired();
			}
		}
	};
	// assign an unassigned specimen to the current case
	this.AssignSpecimenToCase = function(specimenId)
	{
		if (confirm('Assign this Specimen to the Case?'))
		{

			var caseDiv = jsPAL.getSelectedTabPanelDiv($('#MainTabs'));
			// sanity check, make sure we're really on a case tab
			if (caseDiv.attr('tablename') === 'case')
			{
				var caseId = caseDiv.attr('primarykey');
				if (undefined !== specimenId && '' !== specimenId)
				{
					// NOTE, it is not necessary to call refreshVILRequired when adding a specimen, since
					// specimens without slides don't appear in the DST. When a slide is added,
					// refreshVILRequired will then be called. It is necessary to call it when unassigning a
					// specimen since that specimen may have slides that are in the DST
					if ($.find('.Modified').length > 0)
					{
						// this triggers after CommandBarSaveAll completes
						$(document).one('OperationQueueComplete', function() {
							// add the new specimens, reuse any RFC/eSig parameters that were ented for CommandBarSaveAll
							jsPAL.assignElement("Specimen", specimenId, "Case", caseId, 'PALAssignSpecimenToCase');
						});
						CommandBarSaveAll();
					}
					else
					{
						// PALAddSpecimenToCase handler in Specimens.js will reload the tabs
						jsPAL.assignElement("Specimen", specimenId, "Case", caseId, 'PALAssignSpecimenToCase');
					}
				}
			}
		}
	};
	this.specimenTabClicked = function(tabDiv, selectedTabIndex, uid)
	{
		// the last 3 tabs are Assigned Specimens, Find Specimen and +New Specimen
		// Don't reload the CaseAssembly_Slide_Grid_Specimen grid when any of those tabs are clicked
		if (jsPAL.getTabsForDiv(tabDiv).eq(selectedTabIndex).find('a').hasClass('CaseSpecimenTab') === false)
		{
			// hide the assigned slides tab row, when viewing a tab that is not a specimen tab
			$('#specimenSlideTabs' + uid).hide();
			// if this is the find specimen tab, and the CaseAssembly_UnassignedSpecimen_Grid_Specimen grid has not yet been
			// loaded, then load the grid
			if (jsPAL.getTabsForDiv(tabDiv).eq(selectedTabIndex).find('a').hasClass('findSpecimenTab'))
			{
				var grid = $('#specimenFindSpecimensTabPanel' + uid).find('.ui-jqgrid-btable');
				if (grid.getGridParam('datatype') !== 'json')
				{
					// grid has not been loaded yet, switch its datatype to json and load it
					grid.setGridParam(
					{
						datatype : 'json'
					}).trigger('reloadGrid',
					[
					{
						page : 1
					}]);
				}
			}
			return;
		}
		// load the CaseAssembly_Slide_Grid_Specimen grid with the slides for the currently selected specimen
		// called when a user clicks on a tab in the specimen tabs row
		var specimenId = tabDiv.find('li').eq(selectedTabIndex).attr('specimenid');
		if (undefined === specimenId)
		{
			return;
		}
		$('#specimenSlideTabs' + uid).show();
		this.loadspecimenSlideGrid(specimenId, uid);
	};

	this.loadspecimenSlideGrid = function(specimenId, uid)
	{
		var FilterTables = new Array();
		var FilterColumns = new Array();
		var FilterOperators = new Array();
		var FilterValues = new Array();

		FilterTables.push('Slide');
		FilterColumns.push('ParentId');
		FilterOperators.push('=');
		FilterValues.push(specimenId);
		FilterTables.push('Slide');
		FilterColumns.push('ParentTable');
		FilterOperators.push('=');
		FilterValues.push('Specimen');
		// switch grid data type from local to json
		$('#specimenSlideGridTabPanel' + uid).find('.ui-jqgrid-btable').setGridParam(
		{
			datatype : 'json'
		});
		jsPAL.LoadFilteredGrid('CaseAssembly_Slide_Grid_Specimen', 'specimenSlideGridTabPanel' + uid, FilterTables, FilterColumns, FilterOperators, FilterValues);
	};
	this.addSpecimenImageThumbnail = function(imageId)
	{
		if (SystemParms.DisplaySpecimenImagesInDetails)
		{
			var tabDiv = $('.specimenTabs').parent();
			var specimenDiv = jsPAL.getSelectedTabPanelDiv(tabDiv);
			var viewImagesDiv = $(specimenDiv).find('div.ViewImages');
			if (viewImagesDiv.length === 0)
			{
				// insert a ViewImages div into the specimen fieldset
				var fieldSet = specimenDiv.find('fieldset.ViewDisplay');
				var specimenId = jsPAL.getSelectedTab(tabDiv).attr('specimenid');
				var caseId = jsPAL.getSelectedTabPanelDiv($('#MainTabs')).attr('primarykey');

				fieldSet.append(('<div  id="Case' + caseId + '_Specimen' + specimenId + '_PaneImages" class=ViewImages><ul><li></li></ul></div>'));
				viewImagesDiv = specimenDiv.find('div.ViewImages');
			}
			var random = Math.floor(Math.random() * 10000);
			var viewImagesUl = viewImagesDiv.find('ul');
			var viewImagesLi = viewImagesUl.find('li');
			if (viewImagesLi.length === 0)
			{
				viewImagesUl.append('<li></li>');
				viewImagesLi = viewImagesUl.find('li');
			}
			// don't add the thumbnail div it it is already there, i.e. user is reassigning it to the specimen that it is already assigned to
			if (viewImagesLi.find('div[imageid="' + imageId + '"]').length == 0)
			{
				var imageURL = '/imageserver/@@' + SystemParms.AuthToken + '/@' + imageId + '?0+0';
				var specimenLabel = jsPAL.getSelectedTabText($(viewImagesLi).closest('.ui-tabs'));
				var thumbnailDiv = $('<div class="thumbnailDiv" imageid="' + imageId + '">' + '<a href="" style="text-decoration: none;">' + '<span style="white-space: nowrap;"><span class="hoverbase">' + '<img border="0" height="' + SystemParms.SpecimenImageThumbnailHeight + '" src="/imageserver/@@' + SystemParms.AuthToken + '/@' + imageId + '?0+0+0+' + SystemParms.SpecimenImageThumbnailHeight
						+ '+-1+80+S+0+' + random + '" onerror="ImageLoadError(this);" alt="" class="ImageDelay" ' + 'image="/imageserver/@@' + SystemParms.AuthToken + '/@' + imageId + '?0+0+0+' + SystemParms.SpecimenImageThumbnailHeight + '+-1+80+S+0+' + random + '"></span></span></a><br><a onclick="if (!hasClass (this, \'Disabled\')) jsPAL.deleteElement(' + imageId
						+ ', \'Specimen\', this, \'PALDeleteSpecimenThumbnail\', true);return false;" class="BulkLink thumbnailDelLink" title=\'Delete this Image from the Specimen\' href=\'#\'>Delete Image</a></div>');
				viewImagesLi.append(thumbnailDiv);
				thumbnailDiv.find('a:first').attr('onclick', GetGrossImageOnClick(imageURL, specimenLabel));
			}
		}
	};
};

function GetGrossImageOnClick(imageURL, specimenLabel)
{
	return 'ViewGrossImageInBrowser("' + imageURL + '", "' + specimenLabel + '");return false;'
}

// bind various specimen related event handlers
$(document).ready(function()
{
	// exit if not in PAL Mode
	if (false === isPALMode())
	{
		return;
	}

	// bind PALAddSpecimenToCase and PALAssignSpecimenToCase handler. Removes all existing specimen tabs, then reloads the specimen tabs
	$(document).bind('PALAddSpecimenToCase PALAssignSpecimenToCase', function(event, eventData)
	{
		// TableName should always be specimen, but check just to be sure
		if (eventData.TableName === 'Specimen')
		{
			// get the specimen tab panel div (assumption is that the specimen tab is currently selected)
			var tabPanel = jsPAL.getSelectedTabPanelDiv($('#CaseAssemblyTabs'));
			// get the case id
			var caseId = tabPanel.find('.ViewInformation').attr('caseId');
			// get the cList name for the tab panel
			var listName = tabPanel.find('.ViewInformation').attr('clistname');
			// remove the Specimen cList object
			if (undefined !== listName && '' !== listName)
				GlobalList.RemoveList(listName);
			// open new set of specimen tabs, including the newly added specimen(s)
			Ajax(
			{
				type : 	"POST",
				url : 	"/PALModules/healthcare/CommonViewDisplay.php",
				data : 	"workFlow[0]=CaseAssembly" +
						"&viewName[0]=CaseAssembly_Specimens_CaseToSpecimen" +
						"&renderMode[0]=MultiColumnByRow" +
						"&Table[0][0]=Case&Table[0][1]=Specimen" +
						"&FieldName[0][0]=Id&FieldName[0][1]=Id" +
						"&FieldOperator[0][0]=%3D&FieldOperator[0][1]=<>" +
						"&FieldValue[0][0]=" + caseId + "&FieldValue[0][1]=" +
						// SecondPageURL is URL encoded
						"&SecondPageURL=/PALModules/Healthcare/CustomPages/CaseAssemblySpecimen.php%3FworkFlow%3DCaseAssembly%26CaseId%3D" + caseId,
				success : function(msg, textStatus, jqXHR)
				{
					msg = ParseAjaxResponse(msg, 'html');
					if (msg)
					{
						// remove the existing set of specimen tabs
						tabPanel.empty();
						// add the new set of specimen tabs
						tabPanel.append($.trim(msg));
						// refresh the DST and uScope
						jsPAL.viewer.refreshVILRequired();
					}
				}
			});
		}
	});
	// bind PALDeleteSpecimenFromCase handler. Deletes a specimen tab
	$(document).bind('PALDeleteSpecimenFromCase', function(event, eventData)
	{
		// TableName should always be specimen, but check just to be sure
		// ControlId is the id of the button that was clicked to delete this specimen
		if (eventData.TableName === 'Specimen' && undefined !== eventData.ControlId && undefined !== eventData.Ids)
		{
			removeSpecimenTab(eventData.Ids, eventData.ControlId);
		}
	});
	// bind PALAssignSpecimenToCase handler. Adds a specimen tab
	$(document).bind('PALAssignSpecimenToCase', function(event, eventData)
	{
		// TableName should always be specimen, but check just to be sure
		if (eventData.TableName === 'Specimen' && undefined !== eventData.Ids)
		{
			var parentDiv = $('.specimenTabs').filter(':visible').closest('.ViewInformation');
			buildSpecimenTab($('.specimenTabs').filter(':visible'), eventData.Ids, parentDiv.attr('caseid'), 'CaseAssembly', 'CaseAssembly_Specimens_CaseToSpecimen');
		}
	});
	// bind PALUnassignSpecimenFromCase handler. Deletes a specimen tab
	$(document).bind('PALUnassignSpecimenFromCase', function(event, eventData)
	{
		// TableName should always be specimen, but check just to be sure
		// ControlId is the id of the button that was clicked to unassign this specimen
		if (eventData.TableName === 'Specimen' && undefined !== eventData.ControlId && undefined !== eventData.Ids)
		{
			removeSpecimenTab(eventData.Ids, eventData.ControlId);
		}
	});
});
